export default __webpack_public_path__ + "static/slide2-722fdf154c2dedc191cfa6a35403629f.jpg";